import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "p-7" }
const _hoisted_2 = { class: "col-span-12" }
const _hoisted_3 = { class: "col-span-12" }
const _hoisted_4 = { class: "col-span-12" }
const _hoisted_5 = { class: "col-span-12" }
const _hoisted_6 = { class: "col-span-12" }
const _hoisted_7 = { class: "col-span-6" }
const _hoisted_8 = { class: "col-span-12" }
const _hoisted_9 = { class: "col-span-12" }

import AdminLayout from '@/layouts/AdminLayout.vue';
import TabComponent from '@/components/TabComponent.vue';
import FormSection from '@/components/FormSection.vue';
import TextInput from '@/components/inputs/TextInput.vue';
import SuccessModal from '@/components/modal/SuccessModal.vue';
import ErrorModal from '@/components/ErrorModal.vue';
import PageLoader from '@/components/PageLoader.vue';
import DropzoneInput from '@/components/inputs/DropzoneInput.vue';
import ButtonComponent from '@/components/ButtonComponent.vue';
import MultiselectInput from '@/components/inputs/MultiselectInput.vue';

import Packages from '@/classes/Packages';
import DropdownData from '@/classes/DropdownData';
import { useRoute } from 'vue-router';
import { ref, onMounted, watch } from 'vue';
import { checkForInvalidResponse } from '@/helpers/PageHelper';


/**
 * ********************************
 * Data 
 * ********************************
 */

export default /*@__PURE__*/_defineComponent({
  __name: 'ShowPage',
  setup(__props) {

const route       = useRoute();
const form        = ref({})
const loader      = ref(false)
const showError   = ref(false);
const packageName = ref(route.params.name);
const companies     = ref([]);
const attachedFile = ref();
const errorMsg         = ref()
const errors      = ref([])
const showSuccess      = ref(false)
const showConfirmation = ref(false)

const extBase64Data = ref<any>(null);
const extFileType = ref<any>(null);
const extFileName = ref<any>(null);
const extFileSize = ref<any>(null);

const tabs: { name: string, href: string, allowed: boolean }[] = [
    {
        name: 'Information',
        href: `/contents/packages/show/${packageName.value}`,
        allowed: true
    },
    {
        name: 'Schedule',
        href: `/contents/packages/schedule/${packageName.value}`,
        allowed:
            window.$hasPermission('update-package-and-rider-schedule')
    },
];

/**
 * ********************************
 * Fetch Data 
 * ********************************
 */

const fetchPackage = async () => {
    try {
        loader.value = true;
        const response   = await Packages.showPackage(packageName.value);
        const packageFee = response.data[0].package_line.reduce((a,r) => a + parseFloat(r.item_fee), 0);
        const associated_company = response.data[0].associated_company.map((item:any) => parseInt(item.company_id));

        attachedFile.value = response.data[0].file_attachment;
        let fileAttachment = null;
        
        if (response.data[0].file_attachment) {
            const base64Data =  response.data[0].file_attachment;

            extBase64Data.value = base64Data;
            extFileType.value = 'application/pdf';
            extFileName.value = packageName.value;
            const paddedLength = base64Data.length - (base64Data.endsWith('==') ? 2 : base64Data.endsWith('=') ? 1 : 0);
            extFileSize.value = Math.floor((paddedLength * 3) / 4);

            // Check if it's a base64 string
            if (typeof base64Data === 'string' && base64Data.startsWith('data:')) {
                // Get the MIME type from the base64 string
                const mimeType = base64Data.split(';')[0].split(':')[1];
                // Convert base64 to blob
                const byteCharacters = atob(base64Data.split(',')[1]);
                const byteNumbers = new Array(byteCharacters.length);
                for (let i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                }
                const byteArray = new Uint8Array(byteNumbers);
                const blob = new Blob([byteArray], { type: mimeType });
                
                // Create File object from Blob
                fileAttachment = new File([blob], packageName.value, { type: mimeType });
            }
        }

        // let fileAttachment = null;
        // if (response.data[0].file_attachment) {
        //     const base64Data = response.data[0].file_attachment;

        //     extBase64Data.value = base64Data;
        //     extFileType.value = 'application/pdf';
        //     extFileName.value = packageName.value;
        //     const paddedLength = base64Data.length - (base64Data.endsWith('==') ? 2 : base64Data.endsWith('=') ? 1 : 0);
        //     extFileSize.value = Math.floor((paddedLength * 3) / 4);

        //     // Check if it's a base64 string
        //     if (typeof base64Data === 'string' && base64Data.startsWith('data:')) {
        //         // Get the MIME type from the base64 string
        //         const mimeType = base64Data.split(';')[0].split(':')[1];
        //         // Convert base64 to blob
        //         const byteCharacters = atob(base64Data.split(',')[1]);
        //         const byteNumbers = new Array(byteCharacters.length);
        //         for (let i = 0; i < byteCharacters.length; i++) {
        //             byteNumbers[i] = byteCharacters.charCodeAt(i);
        //         }
        //         const byteArray = new Uint8Array(byteNumbers);
        //         const blob = new Blob([byteArray], { type: mimeType });
                
        //         // Create File object from Blob
        //         fileAttachment = new File([blob], packageName.value, { type: mimeType });
        //     }
        // }

        const data = {
            package_name: response.data[0].package_name,
            package_id  : response.data[0].package_id,
            package_code: response.data[0].package_code,
            package_line: response.data[0].package_line,
            package_type: response.data[0].package_type,
            package_fee : packageFee,
            associated_company : associated_company ?? [],
            file_attachment: fileAttachment,
        };

        Object.assign(form.value, data);

    } catch (error) {
        loader.value    = false;
        showError.value = true;
        errorMsg.value  = error?.response?.data?.message || 'Error occurred, please try again';

        checkForInvalidResponse(error, '/contents/packages')
    }
    finally{
        loader.value = false
    }
}

/**
 * Fetch companies
 */
const fetchCompanies = async () => {
    const response = await DropdownData.getCompanies();
    companies.value = response.data.response.map((company: any) => ({
        id: company.id,
        label: company.name,
        value: company.id
    }));
}

const submitPackages = async () => {
    loader.value = true;

    const packageId = form.value.package_id;

    if (!form.value.file_attachment) {
        showError.value = true;
        errorMsg.value = "Please attach a file before submitting.";
        loader.value = false;
        return;
    }

    if (!form.value.associated_company || form.value.associated_company.length === 0) {
        showError.value = true;
        errorMsg.value = "Please select at least one participating company.";
        loader.value = false;
        return;
    }

    try {
        const payload = {
            package_id: packageId,
            file_attachment: null,
            associated_company: [],
        };
        
        // Append the file
        if (form.value.file_attachment instanceof File) {
            const base64File = await new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = () => {
                    resolve(reader.result);
                };
                reader.onerror = reject;
                reader.readAsDataURL(form.value.file_attachment);
            });

            payload.file_attachment = base64File;
        }
        
        // Append participating companies
        if (form.value.associated_company || form.value.associated_company.length > 0) {
            const formattedCompanies = form.value.associated_company.map(selectedId => {
            const companyDetails = companies.value.find(company => company.id === parseInt(selectedId));
                return {
                    company_id: parseInt(selectedId),
                    company_name: companyDetails?.label ?? 'Company Name'
                };
            });

            payload.associated_company = formattedCompanies;
        }

        const response = await Packages.updatePackage(payload);

        if (response.data.response && response.data.result_status === 200 && response.data.message === 'Success') {
            console.log('Package updated successfully');
            showSuccess.value = true;
        } else {
            showError.value = true;
            errorMsg.value = "Failed to update the package. Please try again.";
        }
    } catch (error) {
        console.log(error);
        showError.value = true;
        errorMsg.value = error.response?.data?.message || "An error occurred. Please try again later.";
        if (error.response?.status === 422) {
            errors.value = error.response.data.errors;
        }
        if (error.response?.status === 401) {
            window.location.replace('/login');
        }
    } finally {
        loader.value = false;
    }
}

const stringToBlob = (content: string, mimeType: string): Blob => {
    // Convert the string to a Blob
    const blob = new Blob([content], { type: mimeType });
    return blob;
}

const getFileTypeFromString = (content: string): string => {
    // This is a simple approach to guess the file type based on the content
    // You might want to expand this for more accurate detection
    if (content.startsWith('<?xml')) {
        return 'application/xml';
    } else if (content.startsWith('{') || content.startsWith('[')) {
        return 'application/json';
    } else if (content.startsWith('<!DOCTYPE html>') || content.includes('<html')) {
        return 'text/html';
    } else {
        return 'text/plain'; // Default to plain text if unable to determine
    }
}

const closeSuccessModal = ():void => {
    location.reload();
}

const removeAttachment = () => {
    form.value.file_attachment = null;
    extBase64Data.value = null;
    extFileType.value = null;
    extFileName.value = null;
    extFileSize.value = null;
    console.log('Attachment removed');
}

/**
 * ********************************
 * Watchers
 * ********************************
 */

// Watch for changes to the attachedFile
watch(() => form.value.file_attachment, (newFile) => {
  if (newFile) {
    console.log('New file attached (from watch):', newFile);
  } else {
    console.log('No file attached (from watch)');
  }
}, { deep: true });

onMounted(() => {
    fetchPackage();
    fetchCompanies();
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AdminLayout, {
    title: "View Package",
    "show-back": "",
    backUrl: "/contents/packages"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createVNode(TabComponent, { tabs: tabs })
      ]),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(FormSection, null, {
          title: _withCtx(() => [...(_cache[12] || (_cache[12] = [
            _createTextVNode(" Package Information ", -1)
          ]))]),
          description: _withCtx(() => [...(_cache[13] || (_cache[13] = [
            _createTextVNode(" Relevant data and other details ", -1)
          ]))]),
          form: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(TextInput, {
                id: "package_name",
                name: "package_name",
                disabled: "",
                label: "Package Name",
                placeholder: "Package Name",
                modelValue: form.value.package_name,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.package_name) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(TextInput, {
                id: "package_type",
                name: "package_type",
                disabled: "",
                label: "Package Type",
                placeholder: "Package Type",
                modelValue: form.value.package_type,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.package_type) = $event))
              }, null, 8, ["modelValue"])
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(form.value.package_line, (package_line) => {
              return (_openBlock(), _createElementBlock(_Fragment, { key: package_line }, [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(TextInput, {
                    modelValue: package_line.items.item_cat.item_category,
                    id: package_line.item_id + 'item_category',
                    name: package_line.item_id + 'item_category',
                    disabled: "",
                    label: "Item Category",
                    placeholder: "Item Category"
                  }, null, 8, ["modelValue", "id", "name"])
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(TextInput, {
                    modelValue: package_line.items.item_name,
                    id: package_line.item_id + 'item_name',
                    name: package_line.item_id + 'item_name',
                    disabled: "",
                    label: "Item",
                    placeholder: "Item"
                  }, null, 8, ["modelValue", "id", "name"])
                ])
              ], 64))
            }), 128)),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(TextInput, {
                id: "rider_name",
                name: "rider_name",
                disabled: "",
                label: "Rider Name",
                placeholder: "Rider Name",
                modelValue: form.value.rider_name,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.rider_name) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(TextInput, {
                id: "package_fee",
                name: "package_fee",
                modelValue: form.value.package_fee,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.value.package_fee) = $event)),
                disabled: "",
                "add-on-left": "",
                "add-on-text": "₱",
                label: "Package Fee",
                placeholder: "Package Fee"
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(MultiselectInput, {
                modelValue: form.value.associated_company,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.value.associated_company) = $event)),
                id: "associated_company",
                name: "associated_company",
                label: "Participating Companies",
                placeholder: "Participating Companies",
                searchable: "",
                mode: "tags",
                options: companies.value
              }, null, 8, ["modelValue", "options"])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(DropzoneInput, {
                label: "Attachments",
                path: form.value.file_attachment,
                "onUpdate:path": _cache[5] || (_cache[5] = ($event: any) => ((form.value.file_attachment) = $event)),
                file: form.value.file_attachment,
                "onUpdate:file": _cache[6] || (_cache[6] = ($event: any) => ((form.value.file_attachment) = $event)),
                accept: "application/pdf",
                description: "Max File Size: 2MB · File Type: PDF",
                "ext-source": extBase64Data.value,
                "ext-file-type": extFileType.value,
                "ext-file-name": extFileName.value,
                "ext-file-size": extFileSize.value,
                "onDelete:file": _cache[7] || (_cache[7] = ($event: any) => (removeAttachment()))
              }, null, 8, ["path", "file", "ext-source", "ext-file-type", "ext-file-name", "ext-file-size"])
            ])
          ]),
          actions: _withCtx(() => [
            _createVNode(ButtonComponent, { onClick: submitPackages }, {
              default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                _createTextVNode(" Save Changes ", -1)
              ]))]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _createVNode(SuccessModal, {
        show: showSuccess.value,
        onCancel: _cache[8] || (_cache[8] = ($event: any) => (closeSuccessModal())),
        onConfirm: _cache[9] || (_cache[9] = ($event: any) => (closeSuccessModal())),
        "action-text": "Close",
        title: "Package Updated",
        content: "Package updated Successfully!"
      }, null, 8, ["show"]),
      _createVNode(ErrorModal, {
        width: "w-[548px]",
        title: "Warning",
        "action-text": "Close",
        "cancel-text": "Go back",
        show: showError.value,
        onClose: _cache[10] || (_cache[10] = ($event: any) => (showError.value = false)),
        onConfirm: _cache[11] || (_cache[11] = ($event: any) => (showError.value = false))
      }, {
        content: _withCtx(() => [
          _createTextVNode(_toDisplayString(errorMsg.value), 1)
        ]),
        _: 1
      }, 8, ["show"]),
      (loader.value)
        ? (_openBlock(), _createBlock(PageLoader, { key: 0 }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})